<script>
import flagEn from '@/assets/images/en.png'
import flagPl from '@/assets/images/pl.png'

export default {
  name: 'LocaleButtons',
  data: function () {
    return {
      flagEn,
      flagPl
    }
  },
  methods: {
    changeLocale(lang) {
      this.$i18n.locale = lang
    }
  }
}
</script>

<template lang="pug">
.locale-buttons
  button.btn.btn-flag(type="button" v-ea-click="() => { changeLocale('en') }")
    img.mr-2(:src="flagEn" alt="en flag")
    span EN
  button.btn.btn-flag(type="button" v-ea-click="() => { changeLocale('pl') }")
    img.mr-2(:src="flagPl" alt="pl flag")
    span PL
</template>

<style scoped lang="scss">
.locale-buttons {
  display: flex;
  align-items: center;

  .btn-flag {
    display: flex;
    align-items: center;
    font-size: 1.4rem;
    font-weight: bold;
    padding: 1.4rem;

    img {
      border: 1px solid gray;
      width: 3rem;
    }
  }
}
</style>
